/* otf-address-skip.js — 2 Sep 2026, Bu Site. Rewritten 17 Sep 2026.

   WHAT THIS DOES NOW. The order sheet collects a structured Kuwait delivery
   address (otf-address-fields.js). This file puts that address onto the cart so
   Shopify's checkout opens with the name, the address line, the area, the
   governorate and the phone ALREADY FILLED, and the customer types only the
   Block and pays.

   WHY BLOCK IS NOT WRITTEN HERE ANY MORE, 17 Sep 2026 — settled with evidence,
   do not re-open. Kuwait's checkout has a REQUIRED Block box and NOTHING can
   pre-fill it. There is no district/block/extendedFields member in
   CartDeliveryAddressInput, MailingAddressInput or CartSelectableAddressInput on
   ANY Storefront API version through unstable; none in the Admin API; and a
   draft order renders the same empty box. Shopify writes that box INTO address2
   when the customer submits and NEVER reads address2 back INTO it — the field is
   one-way. Four encodings were tried (U+2060+block, block plain, block+U+2060,
   line2+U+2060+block) and all four rendered the box empty, which is what proved
   it is not an encoding problem. Writing address2 therefore bought nothing and
   cost the customer a second typing of their own block number on our sheet, so
   the sheet no longer asks and this file no longer sends it. The block still
   reaches the order: Shopify puts it in address2 on submit, which is where the
   drivers and any routing hand-off read it. CEO, 17 Sep 2026: "i'll see how you
   fix the 'block' box issue and prefill everything for the customers for easy
   checkout."

   WHAT IT USED TO DO. Round 2 (2 Sep) handled one case only: the gift where the
   buyer does not know the address ("Call them for the address"), by sending the
   customer to /checkout with "-" pre-filled in the URL. That case is still here,
   but it now writes a sentence a human can act on instead of "-" — a packing
   slip that reads "-" helps nobody.

   TWO ROADS INTO CHECKOUT, and only one of them can reach Block.

   1. THE CART (used when a Storefront token is present). Kuwait's checkout runs
      Shopify's "additional address fields" format: a REQUIRED Block input
      (`district`). cartDeliveryAddressesAdd writes the whole delivery address
      onto the cart, Block included. Shopify stores Block inside address2 as
      line2 + U+2060 + block (its open-source Worldwide library, KW rule), so a
      block of "8" with no second line would be written as "⁠8" — see the note
      above for why we no longer do this.

   2. THE URL (the fallback when there is no token). Proven with curl on this
      store, 2 Sep and re-proven 17 Sep: for an existing cart,
      /checkout?checkout[shipping_address][...] fills first_name, last_name,
      address1, city, province, country and the undocumented phone.
      IT CANNOT REACH BLOCK. Re-tested 17 Sep 2026 three ways on a live cart:
      address2 with the U+2060 joiner, address2 plain, and a district parameter.
      The joiner value does ride into the checkout session's
      UnvalidatedAddressParameters, but the Kuwait form has no address2 input at
      all and the `district` input renders empty every time; `district` as a URL
      parameter is rejected outright (address2 comes back null). So on the URL
      road the customer still types the Block, and nothing else.

   THE TOKEN. A PUBLIC Storefront API access token, read from this script tag's
   data-sf-token attribute, rendered by snippets/otf-storefront-token.liquid.
   Public tokens are designed to sit in client code. The Headless sales channel
   is ALREADY installed on this store (publication "October Twenty Flowers
   Headless", confirmed 17 Sep 2026), so the token is a copy-paste from
   admin -> Sales channels -> Headless -> storefront -> public access token.
   With the snippet empty this file silently takes road 2.

   HOW IT ATTACHES. From the outside of fluid-motion.js, which is 106 KB
   minified and deliberately not edited (same principle as fluid-rv-sheet.js,
   fluid-sub.js, otf-sheet-locale.js, otf-slot-cutoff.js). Its submit() saves
   the order attributes with fetch('/cart/update.js') and then does
   location.href = '/checkout'. This file wraps window.fetch, recognises that
   one request, lets it complete, writes the address, then navigates to checkout
   itself and HOLDS the theme's promise so the theme's own plain '/checkout'
   never fires. If the page is somehow still here six seconds later the promise
   is released and the site behaves exactly as it did before this file existed.
   The tidier long-term fix is one token inside fluid-motion.js
   (location.href = window.OTF_CHECKOUT_URL || '/checkout'); do that next time
   that file is rebuilt from source, then delete this wrapper.

   LOAD ORDER. otf-address-fields.js must load AFTER this file: the last wrapper
   installed on window.fetch runs first, so the attributes are merged before
   this file reads them.
*/
(function () {
  'use strict';
  var COUNTRY = 'KW';
  var PROVINCE_FALLBACK = 'Hawalli';   // URL pre-fill needs a zone name
  var HOLD_MS = 6000;
  var SF_VERSION = '2025-07';
  var USE_URL_AFTER_CART = false;      // when the cart carries the address, open a plain /checkout

  var ZONE_NAME = {
    'KW-KU': 'Al Asimah', 'KW-HA': 'Hawalli', 'KW-FA': 'Al Farwaniyah',
    'KW-AH': 'Al Ahmadi', 'KW-JA': 'Al Jahra', 'KW-MU': 'Mubarak Al-Kabeer'
  };

  if (window.__otfAddressSkip || typeof window.fetch !== 'function') return;
  window.__otfAddressSkip = true;

  var script = document.currentScript;
  var SF_TOKEN = ((script && script.getAttribute('data-sf-token')) || '').trim();
  var realFetch = window.fetch;

  /* SAY OUT LOUD WHETHER THE TOKEN IS THERE AND WHETHER IT WORKED.
     17 Sep 2026: the CEO reported pasting a token once and it "didn't work", and
     nobody could tell him where it went — every copy of
     snippets/otf-storefront-token.liquid on all 13 themes is the same empty file.
     Part of why it looked like nothing happened is that this file used to fail
     ENTIRELY SILENTLY: a bad token, a wrong token type or a rejected mutation all
     ended in .catch(return false) and the customer was quietly sent down the URL
     road, which cannot fill Block. From now on the reason is readable.
     Open the preview, press Continue, look at the console, or read window.OTF_SF.
     THE TOKEN VALUE IS NEVER LOGGED — only its length and its shape. */
  window.OTF_SF = {
    token: !!SF_TOKEN,
    length: SF_TOKEN.length,
    shape: !SF_TOKEN ? 'none'
      : /^[0-9a-f]{32}$/i.test(SF_TOKEN) ? 'public storefront token (32 hex) - correct'
      : /^shp(at|ss|ca)_/.test(SF_TOKEN) ? 'WRONG KIND - this is an Admin/private token, not a public Storefront token'
      : 'unrecognised shape',
    cartAddress: null,
    reason: 'not attempted yet'
  };
  try {
    console.info('[otf-address] storefront token: ' + window.OTF_SF.shape +
      (SF_TOKEN ? ' (' + SF_TOKEN.length + ' chars)' : '') +
      ' — without a correct one nothing can be pre-filled at checkout.');
  } catch (e) {}
  function note(ok, why) {
    window.OTF_SF.cartAddress = ok;
    window.OTF_SF.reason = why;
    try {
      console.info('[otf-address] cart delivery address ' + (ok ? 'WRITTEN' : 'NOT written') + ' — ' + why);
    } catch (e) {}
    return ok;
  }

  function isCartUpdate(input, init) {
    if (!init || String(init.method || 'GET').toUpperCase() !== 'POST') return false;
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return /\/cart\/update\.js(?:\?|$)/.test(url) && typeof init.body === 'string';
  }

  /* The recipient's name and phone go on the shipping address only when this is
     a gift. For the buyer's own order the checkout already knows who they are,
     and guessing would overwrite a name we were never told. */
  function person(attrs) {
    if (!attrs || attrs.Gift !== 'Yes') return { first: '', last: '', phone: '' };
    var name = String(attrs['Recipient name'] || '').replace(/\s+/g, ' ').trim();
    var parts = name ? name.split(' ') : [];
    var first = parts.shift() || '';
    var last = parts.join(' ') || first;
    var digits = String(attrs['Recipient phone'] || '').replace(/\D+/g, '');
    var phone = digits.length === 8 ? '+965' + digits : (digits ? '+' + digits : '');
    return { first: first, last: last, phone: phone };
  }

  /* What otf-address-fields.js published for this order, or null. */
  function delivery() {
    var s = window.OTF_ADDR;
    if (!s || !s.ready || !s.address) return null;
    var a = s.address;
    if (!a.address1 || !a.city) return null;
    return {
      address1: a.address1,
      city: a.city,
      provinceCode: ZONE_NAME[a.provinceCode] ? a.provinceCode : 'KW-HA',
      zip: a.zip || ''
    };
  }

  function checkoutUrl(attrs, d) {
    var r = person(attrs);
    var p = [
      ['checkout[shipping_address][address1]', d.address1],
      ['checkout[shipping_address][city]', d.city],
      ['checkout[shipping_address][province]', ZONE_NAME[d.provinceCode] || PROVINCE_FALLBACK],
      ['checkout[shipping_address][country]', COUNTRY]
    ];
    if (r.first) {
      p.unshift(['checkout[shipping_address][last_name]', r.last]);
      p.unshift(['checkout[shipping_address][first_name]', r.first]);
    }
    if (r.phone) p.push(['checkout[shipping_address][phone]', r.phone]);
    var q = [];
    for (var i = 0; i < p.length; i++) {
      q.push(encodeURIComponent(p[i][0]) + '=' + encodeURIComponent(p[i][1]));
    }
    return '/checkout?' + q.join('&');
  }

  /* SAME ORIGIN, DELIBERATELY. This used to build the URL from
     window.Shopify.shop, which on this store is "fa4bb8-66.myshopify.com" — NOT
     the domain the customer is on. That made every call a cross-origin request
     to a second Shopify host, and the first live test of the token (17 Sep 2026)
     failed with a bare "Failed to fetch" because of it. Shopify serves the
     Storefront API on the custom domain too — proven with curl the same day:
     POST https://octobertwenty.shop/api/2025-07/graphql.json with this token
     returns 200. location.host keeps it same-origin, which is faster, survives
     an ad-blocker rule on *.myshopify.com, and can actually be tested.
     Shopify.shop stays only as a fallback for a page served from somewhere odd. */
  function sfEndpoint() {
    var shop = location.host || (window.Shopify && window.Shopify.shop);
    return 'https://' + shop + '/api/' + SF_VERSION + '/graphql.json';
  }

  /* Puts the delivery address on the cart itself, Block included.
     Resolves true only when Shopify confirms the address is on the cart. */
  function setCartAddress(attrs, d) {
    if (!SF_TOKEN) return Promise.resolve(note(false,
      'snippets/otf-storefront-token.liquid is empty, so there is no token to use. ' +
      'Paste the PUBLIC Storefront token from admin > Sales channels > Headless > your storefront.'));
    var r = person(attrs);
    var address = {
      address1: d.address1,
      city: d.city,
      provinceCode: d.provinceCode,
      countryCode: COUNTRY
    };
    if (r.first) { address.firstName = r.first; address.lastName = r.last; }
    if (r.phone) address.phone = r.phone;
    var query = 'mutation otfAddr($cartId: ID!, $addresses: [CartSelectableAddressInput!]!) {' +
      ' cartDeliveryAddressesAdd(cartId: $cartId, addresses: $addresses) {' +
      ' cart { id } userErrors { field message } } }';
    return realFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart || !cart.token) throw new Error('no cart token');
        var body = {
          query: query,
          variables: {
            cartId: 'gid://shopify/Cart/' + cart.token,
            addresses: [{
              address: { deliveryAddress: address },
              selected: true,
              oneTimeUse: true,
              validationStrategy: 'COUNTRY_CODE_ONLY'
            }]
          }
        };
        return realFetch(sfEndpoint(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': SF_TOKEN },
          body: JSON.stringify(body)
        });
      })
      .then(function (res) {
        if (res.status === 401 || res.status === 403) {
          throw new Error('Shopify refused the token (HTTP ' + res.status + '). ' +
            'It is either not a PUBLIC Storefront token, or it belongs to a storefront ' +
            'without the unauthenticated_write_checkouts scope.');
        }
        if (!res.ok) throw new Error('Storefront API returned HTTP ' + res.status + '.');
        return res.json();
      })
      .then(function (j) {
        if (j && j.errors && j.errors.length) {
          return note(false, 'Storefront API error: ' + (j.errors[0].message || 'unknown') + '.');
        }
        var x = j && j.data && j.data.cartDeliveryAddressesAdd;
        if (x && x.userErrors && x.userErrors.length) {
          return note(false, 'cartDeliveryAddressesAdd rejected the address: ' +
            (x.userErrors[0].message || 'unknown') + '.');
        }
        if (!(x && x.cart)) return note(false, 'cartDeliveryAddressesAdd returned no cart.');
        return note(true, 'name, address, area, governorate and phone are filled; only Block is left to type.');
      })
      .catch(function (err) { return note(false, (err && err.message) || 'the request failed.'); });
  }

  window.fetch = function (input, init) {
    var attrs = null;
    try {
      if (isCartUpdate(input, init)) {
        var body = JSON.parse(init.body);
        if (body && body.attributes && typeof body.attributes.Gift === 'string') attrs = body.attributes;
      }
    } catch (e) { attrs = null; }
    var d = attrs ? delivery() : null;
    if (!attrs || !d) return realFetch.apply(this, arguments);
    var url = checkoutUrl(attrs, d);
    return realFetch.apply(this, arguments).then(function (r) {
      if (!r || !r.ok) return r;
      return setCartAddress(attrs, d).then(function (onCart) {
        location.href = (onCart && !USE_URL_AFTER_CART) ? '/checkout' : url;
        return new Promise(function (resolve) { setTimeout(function () { resolve(r); }, HOLD_MS); });
      });
    });
  };
})();
